import {FC, useState, useEffect} from 'react'
import TypeProposalDocument from './TypeProposalDocument'
import JSZip from 'jszip'
import {saveAs} from 'file-saver'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'

const api = new Api()

type Props = {
  radioButton: boolean
  title: string
  data: any
  handleInput: any
  dataFile: any
  isAdmin: boolean
  errors: any
  fieldRefs: any
}

const TypeProposalContent: FC<Props> = ({
  radioButton,
  title,
  data,
  handleInput,
  dataFile,
  isAdmin,
  errors,
  fieldRefs,
}) => {
  const [loading, setLoading] = useState(false)

  const onSelectedRadio = (data: any) => {
    handleInput(data?.name, data?.id)
  }

  const onInputNote = (data: any) => {
    handleInput(`catatan_${data?.name}`, data?.value)
  }

  const downloadAllFile = () => {
    setLoading(true)
    api
      .downloadAllFile(data?.id)
      .then((response: any) => {
        const {data} = response?.data
        setLoading(false)

        downloadAllPDFasZip(data?.files)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error?.response
        toast.error(data?.message ?? data?.meta?.message)
      })
  }

  const downloadAllPDFasZip = async (files: Record<string, string>) => {
    const zip = new JSZip()

    // Tambahkan setiap file ke dalam zip
    Object.entries(files).forEach(([name, base64]) => {
      const cleanedBase64 = base64.replace(/^data:application\/pdf;base64,/, '')
      zip.file(`${name}.pdf`, cleanedBase64, {base64: true})
    })

    // Generate dan simpan zip
    const blob = await zip.generateAsync({type: 'blob'})
    saveAs(blob, 'semua_dokumen.zip')
  }

  return (
    <div className='card'>
      <div className='p-7 border-bottom'>
        <div className='d-flex align-items-center gap-3'>
          <div className='icon-box px-4 py-2 rounded' style={{backgroundColor: '#EBF3FA'}}>
            <i className='fa fa-solid fa-bars text-dark'></i>
          </div>
          <div className='d-flex justify-content-between align-items-center w-100'>
            <p className='fs-4 fw-bold mb-0'>{title}</p>

            {isAdmin && (
              <button
                type='button'
                className='btn btn-primary btn-sm'
                onClick={downloadAllFile}
                disabled={loading}
              >
                <i className='fa fa-arrow-circle-down me-1'></i>
                {loading ? 'Loading...' : 'Download Pdf'}
              </button>
            )}
          </div>
        </div>
      </div>
      <div className='py-8'>
        <div className='px-8'>
          <div className='d-flex align-items-center mb-8'>
            <i className='fas fa-info-circle me-2 text-dark'></i>
            <div>
              <strong>Information</strong>
              <br />
              <span className='text-muted' style={{fontSize: '0.9rem'}}>
                Silakan isi penilaian dokumen sesuai dengan data yang Anda miliki.
              </span>
            </div>
          </div>

          {/* <div>
            <TypeProposalDocument
              radioButton={radioButton}
              title='Proposal'
              desc='File Proposal'
              file={dataFile?.fileProposalGabungan?.file}
              onSelectedRadio={onSelectedRadio}
              onInputNote={onInputNote}
              name='dokumen_proposal'
              data={data}
              errors={errors}
              fieldRefs={fieldRefs}
              anotherName='dokumen_proposal'
            />
          </div> */}

          {/* <div className='mt-8'>
            <TypeProposalDocument
              radioButton={radioButton}
              title='PPT'
              desc='File BAHAN PRESENTASI'
              file={dataFile?.filePptGabungan?.file}
              onSelectedRadio={onSelectedRadio}
              onInputNote={onInputNote}
              name='dokumen_ppt'
              data={data}
              errors={errors}
              fieldRefs={fieldRefs}
              anotherName='dokumen_ppt'
            />
          </div> */}

          {radioButton == true || isAdmin == true ? (
            <>
              <div className='mt-8'>
                <TypeProposalDocument
                  radioButton={radioButton}
                  title='Surat Keterangan Sehat'
                  desc='Surat Keterangan Sehat Dokter'
                  file={dataFile?.fileKesehatanGabungan?.file}
                  onSelectedRadio={onSelectedRadio}
                  onInputNote={onInputNote}
                  name='dokumen_surat_kesehatan'
                  data={data}
                  errors={errors}
                  fieldRefs={fieldRefs}
                  anotherName='dokumen_kesehatan'
                />
              </div>
              <div className='mt-8'>
                <TypeProposalDocument
                  radioButton={radioButton}
                  title='Surat Keterangan dari Tempat Kerja'
                  desc='Surat Keterangan dari Tempat Kerja'
                  file={dataFile?.fileKerjaGabungan?.file}
                  onSelectedRadio={onSelectedRadio}
                  onInputNote={onInputNote}
                  name='dokumen_surat_kerja'
                  data={data}
                  errors={errors}
                  fieldRefs={fieldRefs}
                  anotherName='dokumen_kerja'
                />
              </div>
              <div className='mt-8'>
                <TypeProposalDocument
                  radioButton={radioButton}
                  title='Surat Pernyataan Komitmen'
                  desc='Surat Pernyataan Komitmen'
                  file={dataFile?.filePernyataanGabungan?.file}
                  onSelectedRadio={onSelectedRadio}
                  onInputNote={onInputNote}
                  name='dokumen_surat_komitmen'
                  data={data}
                  errors={errors}
                  fieldRefs={fieldRefs}
                  anotherName='dokumen_komitmen'
                />
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  )
}

const TypeProposal: FC<Props> = ({
  radioButton,
  title,
  data,
  handleInput,
  dataFile,
  isAdmin,
  errors,
  fieldRefs,
}) => {
  return (
    <TypeProposalContent
      radioButton={radioButton}
      title={title}
      data={data}
      handleInput={handleInput}
      dataFile={dataFile}
      isAdmin={isAdmin}
      errors={errors}
      fieldRefs={fieldRefs}
    />
  )
}

export default TypeProposal
